import { MessageFormatElement } from 'react-intl';

const isLocaleMessageExists = (
  locale: string,
  messages: Record<string, string> | Record<string, MessageFormatElement[]>,
): boolean => {
  return !!messages[locale];
};

export default isLocaleMessageExists;